<div class="container">
  <div class="pt-2">
    <h1 class="page-title">{{ heading1 | globalTranslate }}</h1>
  </div>
  <div tabindex="0" class="hover-red">
    <a class="hover-red btn btn-link" (click)="onPrevious()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16.875"
        height="15.75"
        viewBox="0 0 16.875 15.75"
      >
        <g
          id="_icons_arrow-back-outline"
          data-name="⚛️ icons/arrow-back-outline"
          transform="translate(0)"
        >
          <path
            id="Combined_Shape"
            data-name="Combined Shape"
            d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
            transform="translate(0)"
            fill="#174a7c"
          />
        </g>
      </svg>
      <span class="ps-2">{{ "BACK_TO_PREVIOUS_PAGE" | globalTranslate }}</span>
    </a>
  </div>
  <div class="container">
    <div class="row py-4">
      <div class="card">
        <div class="page_label p-4">
          <h2 class="section-header">{{ heading2 | globalTranslate }}</h2>
          <hr />
          <p>{{ heading3 | globalTranslate }}</p>
          <br />
          <form [formGroup]="coverageSearchForm">
            <div class="row g-3">
              <div class="col-sm-12 col-md-6">
                <div class="coverageSearch">
                  <div class="col-sm-12">
                    <nh-field
                      [attr.aria-required]="true"
                      [isRow]="true"
                      [mandatory]="true"
                      label="{{ 'FIRST_NAME' | globalTranslate }}"
                    >
                      <input
                        type="text"
                        aria-label="firstName"
                        name="firstName"
                        formControlName="firstName"
                        aria-required="true"
                        class="form-control"
                        maxlength="45"
                      />
                    </nh-field>
                  </div>
                  <div class="col-sm-12">
                    <nh-field
                      [attr.aria-required]="true"
                      [isRow]="true"
                      [mandatory]="true"
                      label="{{ 'LAST_NAME' | globalTranslate }}"
                    >
                      <input
                        aria-label="lastName"
                        type="text"
                        name="lastName"
                        formControlName="lastName"
                        aria-required="true"
                        class="form-control"
                        maxlength="45"
                      />
                    </nh-field>
                  </div>
                </div>
                <div class="coverageSearch">
                  <div class="col-sm-12">
                    <nh-field
                      [attr.aria-required]="true"
                      id="ms_dateOfBirth"
                      [mandatory]="true"
                      [isRow]="true"
                      label="{{ 'SOCIAL_SECURITY_NUMBER' | globalTranslate }}"
                      class="label-section"
                    >
                      <input
                        aria-label="ssn"
                        type="text"
                        name="ssn"
                        formControlName="ssn"
                        aria-required="true"
                        class="form-control"
                        placeholder="XXX-XX-XXXX"
                        mask="000-00-0000"
                      />
                    </nh-field>
                  </div>
                  <div class="col-sm-12 col-md-12">
                    <nh-field
                      label="{{ 'DATE_OF_BIRTH' | globalTranslate }}"
                      class="label-section"
                      [isRow]="true"
                    >
                      <nh-datepicker>
                        <input
                          id="ms_dateOfBirth"
                          type="text"
                          class="form-control"
                          name="dateOfBirth"
                          formControlName="dateOfBirth"
                          aria-label="dateOfBirth"
                          placeholder="mm/dd/yyyy"
                          [minDate]="minimumDate"
                          [maxDate]="today"
                          bsDatepicker
                          nh
                          required
                        />
                      </nh-datepicker>
                    </nh-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="row g-3 py-2">
              <div class="d-flex">
                <div tabindex="0">
                  <nh-checkbox
                    name="applicantBehalf"
                    [control]="coverageSearchForm.controls['applicantBehalf']"
                    checkedValue="checked"
                    label="{{ heading4 | globalTranslate }}"
                    [mandatory]="true"
                  ></nh-checkbox>
                </div>
              </div>
            </div>
          </form>
          <br />
          <div class="row g-3">
            <div class="col-12 col-md-3 py-2 py-md-0 order-md-1">
              <button
                class="btn btn-secondary"
                (click)="onSearch()"
                style="text-transform: initial"
                [disabled]="coverageSearchForm.invalid"
              >
                {{ "SEARCH_COVERAGE" | globalTranslate }}&nbsp;
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
          <br />
          @if (rows && rows?.length && isSearchCompleted) {
          <div>
            <h2 class="section-header">
              {{ "SEARCH_RESULTS" | globalTranslate }}
            </h2>
            <hr />
            @if (rows && rows?.length) {
            <ngx-datatable
              class="bootstrap striped"
              #table
              [rows]="rows"
              columnMode="force"
              [headerHeight]="50"
              [footerHeight]="50"
              [rowHeight]="'auto'"
              [limit]="5"
            >
              @for (col of columns; track col) {
              <ngx-datatable-column
                [name]="col.name | globalTranslate"
                [prop]="col.prop"
              ></ngx-datatable-column>
              }
              <ngx-datatable-column name="Select" [width]="180">
                <ng-template
                  ngx-datatable-cell-template
                  let-row="row"
                  let-rowIndex="rowIndex"
                >
                  <div class="d-flex">
                    @if (isSearchCompleted) {
                    <a tabindex="0" role="button" class="view-tennCare-title">
                      <span (click)="resumeAFB()"
                        >{{
                          "CONTINUE_IN_PROGRESS_APPLICATION" | globalTranslate
                        }}
                      </span>
                    </a>
                    }
                  </div>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
            }
          </div>
          } @if (rows && !rows.length) {
          <div>
            <h2 class="section-header">
              {{ "SEARCH_RESULTS" | globalTranslate }}
            </h2>
            <hr />
            <p>{{ "NO_SEARCH_RESULTS" | globalTranslate }}</p>
          </div>
          }
          <div class="pt-2">
            <div class="g-3 justify-content-center d-flex">
              <div class="col-5 col-md-5 d-none d-sm-block">
                <p class="and-border"></p>
              </div>
              <div class="px-1">
                <p class="text-center"><strong>OR</strong></p>
              </div>
              <div class="col-5 col-md-5 d-none d-sm-block">
                <p class="and-border"></p>
              </div>
            </div>
          </div>
          <div class="text-center">
            <button
              (click)="startApp('AFB')"
              class="btn btn-secondary btn-search"
              style="text-transform: initial"
            >
              {{ "START_NEW_APPLICATION" | globalTranslate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>